import { Spiner } from "@components/loaders/spiner";
import { HomeService } from "@services/home.service";
import { SchoolService } from "@services/school.service";
import { useThemeStore } from "@stores/theme.store";
import { useQuery } from "@tanstack/react-query";
import { toRp } from "@utils/helper";
import { Select } from "antd";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { FcFinePrint } from "react-icons/fc";
import { useNavigate } from "react-router-dom";

moment.locale("id");

export const CheckingAccDataPage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [limit, setLimit] = useState<string>("10");

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const { data: laporanUangSaku, isPending: isPendingLaporanUangSaku } =
    useQuery({
      queryKey: [HomeService.queries.GET_DATA_REPORT_BALANCES, nis, limit],
      queryFn: () => HomeService.reportBalances({ nis, limit }),
    });

  useEffect(() => {
    setAppBar({ title: "Rekening Koran", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Rekening Koran",
    });
  }, [setHeader]);

  return (
    <>
      <div className="tw-px-4 tw-pb-20">
        <>
          <div className="tw-bg-other-100 tw-rounded-lg card-body">
            <div className="tw-text-xs tw-mb-1">Filter Data</div>
            <Select
              className="tw-border-other-0 tw-text-base"
              placeholder="Pilih Jumlah Ditampilkan"
              defaultValue={limit}
              style={{ width: "100%" }}
              allowClear
              onChange={(e) => setLimit(e)}
              options={[
                { value: "10", label: "10" },
                { value: "25", label: "25" },
                { value: "50", label: "50" },
                { value: "100", label: "100" },
              ]}
            ></Select>
            <p className="tw-mt-3 tw-text-sm">
              Data yang ditampilkan {limit} data terakhir
            </p>
          </div>

          <div className="tw-bg-other-100 tw-rounded-lg card-body tw-mt-3">
            {isPendingLaporanUangSaku && (
              <div className="tw-py-2 tw-text-center">
                <Spiner className="" />
              </div>
            )}
            {laporanUangSaku?.data?.length === 0 ? (
              <div className="tw-p-8 tw-text-center">
                <FcFinePrint size={50} />
                <div>Data tidak ditemukan</div>
              </div>
            ) : (
              (laporanUangSaku?.data ?? [])
                .sort((a, b) => moment(b.tanggal).diff(moment(a.tanggal)))
                // .filter((i) => i.tipe === "masuk")
                .slice(0, parseInt(limit))
                .map((item, idx) => (
                  <div
                    className="tw-border-solid tw-border-x-0 tw-border-y-1 tw-border-y-other-200 tw-py-1 tw-mb-0.5"
                    key={idx}
                  >
                    <div className="tw-flex tw-justify-between tw-items-center tw-font-semibold">
                      <div className="tw-text-xs tw-font-medium tw-text-other-600">
                        {moment(item.tanggal ?? Date.now()).format(
                          "DD MMMM YYYY"
                        )}
                      </div>
                      <div className="tw-w-1/3 tw-flex tw-justify-end">
                        {item.tipe === "masuk" ? (
                          <span className="tw-px-2 tw-inline-flex tw-items-center tw-rounded-md tw-bg-blue-50 tw-py-1 tw-text-xs tw-font-medium tw-text-blue-700 tw-ring-1 tw-ring-blue-600/10 tw-ring-inset">
                            masuk
                          </span>
                        ) : (
                          <span className="tw-px-2 tw-inline-flex tw-items-center tw-rounded-md tw-bg-red-50 tw-py-1 tw-text-xs tw-font-medium tw-text-red-700 tw-ring-1 tw-ring-red-600/10 tw-ring-inset">
                            keluar
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="tw-flex tw-justify-between tw-items-center tw-font-semibold">
                      <div className="tw-text-sm tw-w-1/2">{item.catatan}</div>
                      <div className="tw-w-1/3 tw-text-end">
                        <div className="tw-text-sm">
                          {item.tipe === "masuk"
                            ? toRp(
                                parseFloat(
                                  ((item.uangsakumasuk ?? "") + "").replace(
                                    ",",
                                    ""
                                  ) ?? 0
                                )
                              )
                            : toRp(
                                parseFloat(
                                  ((item.uangkeluar ?? "") + "").replace(
                                    ",",
                                    ""
                                  ) ?? 0
                                )
                              )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
            )}
          </div>
        </>
      </div>
    </>
  );
};
